// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"baeb4032","171":"48a3e130","404":"1a19c714","453":"f3b3ca27","952":"7014055a"}[chunkId] + ".chunk.js";
};